export default __webpack_public_path__ + "static/media/image.zcode-developers.65b038a0.png";